import styled from '@emotion/styled';

import {
  AdpRunLogo,
  AdpWorkforceNowLogo,
  AsanaLogo,
  CeridianDayforceLogo,
  CsvLogo,
  GitHubLogo,
  GustoLogo,
  JiraLogo,
  JiraDataCenterLogo,
  JustworksLogo,
  LinearLogo,
  NetsuiteLogo,
  PaychexLogo,
  PaylocityLogo,
  QuickbooksLogo,
  RipplingLogo,
  ShortcutLogo,
  TrelloLogo,
  TrinetLogo,
  WorkdayLogo,
  ZenefitsLogo,
  FileLogo,
} from '@neo.tax/shared/assets';
import { transientPropOptions } from '@neo.tax/shared/third-parties/emotion';

import { LogoProps } from './provider-logo.types';

// eslint-disable-next-line @typescript-eslint/explicit-function-return-type
const baseLogoStyles = ({ $isFaded, $isSquare, $size }: LogoProps) => ({
  width: $size,
  height: $size,
  filter: $isFaded ? 'opacity(50%) grayscale(100%);' : undefined,
  borderRadius: !$isSquare ? '50%' : undefined,
});

export const AdpRunLogoStyled = styled(AdpRunLogo, transientPropOptions)(baseLogoStyles);
export const AdpWorkforceNowLogoStyled = styled(AdpWorkforceNowLogo, transientPropOptions)(baseLogoStyles);
export const AsanaLogoStyled = styled(AsanaLogo, transientPropOptions)(baseLogoStyles);
export const CeridianDayforceLogoStyled = styled(CeridianDayforceLogo, transientPropOptions)(baseLogoStyles);
export const CsvLogoStyled = styled(CsvLogo, transientPropOptions)(baseLogoStyles);
export const FileLogoStyled = styled(FileLogo, transientPropOptions)(baseLogoStyles);
export const GitHubLogoStyled = styled(GitHubLogo, transientPropOptions)(baseLogoStyles);
export const GustoLogoStyled = styled(GustoLogo, transientPropOptions)(baseLogoStyles);
export const JiraLogoStyled = styled(JiraLogo, transientPropOptions)(baseLogoStyles);
export const JiraDataCenterLogoStyled = styled(JiraDataCenterLogo, transientPropOptions)(baseLogoStyles);
export const JustworksLogoStyled = styled(JustworksLogo, transientPropOptions)(baseLogoStyles);
export const LinearLogoStyled = styled(LinearLogo, transientPropOptions)(baseLogoStyles);
export const NetsuiteLogoStyled = styled(NetsuiteLogo, transientPropOptions)(baseLogoStyles);
export const PaychexLogoStyled = styled(PaychexLogo, transientPropOptions)(baseLogoStyles);
export const PaylocityLogoStyled = styled(PaylocityLogo, transientPropOptions)(baseLogoStyles);
export const QuickbooksLogoStyled = styled(QuickbooksLogo, transientPropOptions)(baseLogoStyles);
export const RipplingLogoStyled = styled(RipplingLogo, transientPropOptions)(baseLogoStyles);
export const ShortcutLogoStyled = styled(ShortcutLogo, transientPropOptions)(baseLogoStyles);
export const TrelloLogoStyled = styled(TrelloLogo, transientPropOptions)(baseLogoStyles);
export const TrinetLogoStyled = styled(TrinetLogo, transientPropOptions)(baseLogoStyles);
export const WorkdayLogoStyled = styled(WorkdayLogo, transientPropOptions)(baseLogoStyles);
export const ZenefitsLogoStyled = styled(ZenefitsLogo, transientPropOptions)(baseLogoStyles);
